import { Box, styled } from "@mui/material";
import { Button, createShouldForwardPropBlockList, IconButton } from "@pmag/ui-components";

const BREAKPOINT = 1000;

export const BoxContainer = styled(Box)(({ theme }) => ({
    background: theme.palette.core.white,
    paddingBottom: theme.spacing(6),

    [theme.breakpoints.down(BREAKPOINT)]: {
        borderBottom: `1px solid ${theme.palette.core.grey._30}`,
    },

    "& > div:only-child": {
        marginBottom: 0,
    },
}));

export const BoxGrid = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(7),

    [theme.breakpoints.up(BREAKPOINT)]: {
        alignItems: "start",
    },
}));

export const BoxImage = styled(Box)(({ theme }) => ({
    flexShrink: "0",
    width: "90px",
    aspectRatio: "1.5/1",
    position: "relative",

    [theme.breakpoints.up(BREAKPOINT)]: {
        width: "120px",
    },
}));

export const BoxButtons = styled(Box)(({ theme }) => ({
    flexShrink: "0",
    display: "flex",
    rowGap: theme.spacing(2),
    justifyContent: "space-between",

    [theme.breakpoints.up(BREAKPOINT)]: {
        alignItems: "start",
        columnGap: theme.spacing(4),
        flexWrap: "wrap",
    },
}));

export const BoxContent = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up(BREAKPOINT)]: {
        flexDirection: "row",
        columnGap: theme.spacing(4),
        alignSelf: "end",
    },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    alignSelf: "center",

    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));

export const InspectButton = styled(IconButton)(() => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
}));

export const BoxDetailContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing(3),
    flex: 1,

    [theme.breakpoints.up(BREAKPOINT)]: {
        paddingLeft: theme.spacing(4),
    },
}));

export const BoxModelDetails = styled(Box)(() => ({
    display: "flex",
}));

export const BoxPerfectFit = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    marginTop: theme.spacing(6),

    [theme.breakpoints.up(BREAKPOINT)]: {
        marginTop: 0,
    },
}));

export const BoxColumn = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
}));

export interface NavigationButtonProps {
    hidden?: boolean;
}

export const NavigationButton = styled(Button, {
    shouldForwardProp: createShouldForwardPropBlockList(["hidden"]),
})<NavigationButtonProps>(({ theme, hidden }) => ({
    display: hidden ? "none" : "flex",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,

    [theme.breakpoints.up(BREAKPOINT)]: {
        paddingLeft: theme.spacing(4),
    },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    padding: theme.spacing(2, 2, 2, 2),
}));

export const ModelImage = styled("img")<{ isHovering: boolean }>(({ isHovering }) => ({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    ...(isHovering && { opacity: 0.5 }),
}));

export const BoxSeparator = styled(Box)(({ theme }) => ({
    width: "100%",
    height: 1,
    backgroundColor: theme.palette.core.grey._30,
}));

export const BoxVerticalSeparator = styled(Box)(({ theme }) => ({
    width: 1,
    height: 44,
    display: "flex",
    alignSelf: "center",
    backgroundColor: theme.palette.core.grey._30,
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(4),
}));

export const ModalImageBox = styled(Box)(() => ({
    flexShrink: "0",
    width: "100%",
    aspectRatio: "1.5/1",
    position: "relative",
}));
